import { useContext } from "react";
import { StageContext } from "../context/StageContext";
export function useResource(key) {
  var _useContext = useContext(StageContext),
    resources = _useContext.resources;
  return resources.use(key);
}